import { cn } from "@/modules/lib/utils"
import { Switch as SwitchPrimitive } from "@base-ui/react/switch"
import { cva, type VariantProps } from "class-variance-authority"

const switchVariants = cva(
  cn(
    "peer group/switch relative inline-flex shrink-0 cursor-pointer items-center rounded-full border border-transparent shadow-xs outline-none after:-inset-x-3 after:-inset-y-2",
    "focus-visible:border-interactive-border-primary-faded focus-visible:ring-[3px] focus-visible:ring-interactive-border-primary-faded",
    "data-disabled:cursor-not-allowed",
    "data-checked:bg-linear-105 data-checked:from-interactive-background-primary-gradient-from data-checked:to-interactive-background-primary-gradient-to",
    "data-checked:hover:bg-linear-105 data-checked:hover:from-interactive-background-primary-gradient-hover-from data-checked:hover:to-interactive-background-primary-gradient-hover-to",
    "data-checked:data-disabled:bg-interactive-background-primary-disabled data-checked:data-disabled:bg-none",
    "data-checked:data-disabled:hover:bg-interactive-background-primary-disabled data-checked:data-disabled:hover:bg-none",
    "data-unchecked:bg-interactive-background-neutral-faded",
    "data-unchecked:hover:bg-interactive-background-neutral-highlighted",
    "data-unchecked:data-disabled:bg-interactive-background-neutral-disabled",
  ),
  {
    variants: {
      size: {
        md: "h-7 w-11.5",
        sm: "h-5.5 w-8.5",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
)

const switchThumbVariants = cva(
  "pointer-events-none block rounded-full bg-white ring-0 transition-transform data-checked:translate-x-[calc(100%-1px)] data-unchecked:translate-x-1",
  {
    variants: {
      size: {
        md: "size-5",
        sm: "size-4",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
)

export type SwitchProps = SwitchPrimitive.Root.Props & VariantProps<typeof switchVariants>

function Switch({ className, size, ...props }: SwitchProps) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(switchVariants({ size }), className)}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(switchThumbVariants({ size }))}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
